export default class DynamicListController {
  constructor(element) {
    this.element = element
    this.fieldName = element.dataset.dynamicListField
    this.container = element.querySelector('[data-dynamic-list-target="rows"]')
    this.bindEvents()
  }

  bindEvents() {
    this.element.querySelector('[data-action="click->dynamic-list#add"]')
      ?.addEventListener('click', (e) => {
        e.preventDefault()
        this.add()
      })

    this.container.addEventListener('click', (e) => {
      const removeBtn = e.target.closest('[data-action="click->dynamic-list#remove"]')
      if (removeBtn) {
        e.preventDefault()
        this.remove(removeBtn)
      }
    })
  }

  add() {
    const row = document.createElement('div')
    row.className = 'dynamic-list__row'
    row.innerHTML = `
      <input type="text" name="${this.fieldName}" class="input" />
      <button type="button" class="dynamic-list__remove" data-action="click->dynamic-list#remove">&times;</button>
    `
    this.container.appendChild(row)
  }

  remove(button) {
    const rows = this.container.querySelectorAll('.dynamic-list__row')
    if (rows.length <= 1) {
      rows[0].querySelector('input').value = ''
      return
    }
    button.closest('.dynamic-list__row').remove()
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-controller="dynamic-list"]').forEach(el => {
    new DynamicListController(el)
  })
})
